import { ClassName } from '../methodologyDeep/models';

export interface LocalizedName {
  localized_strings: {
    [locale: string]: string;
  };
}

export interface MethodologyCluster {
  id: string;
  name: LocalizedName;
  components_class_name: ClassName.CHARACTERISTIC;
  components_ids: string[];
  phenomenon_id?: string;
  phenomenon_unique_id?: string;
}

export interface MethodologyClusterState {
  component_clusters: MethodologyCluster[];
  loading: boolean;
  error: string | null;
  selectedCluster: MethodologyCluster | null;
}

export const initialMethodologyClusterState: MethodologyClusterState = {
  component_clusters: [],
  loading: false,
  error: null,
  selectedCluster: null
};
